import(/* webpackMode: "eager" */ "/vercel/path0/frontend/app/settings/page.tsx");
